import favicon from '../../assets/favicon/favicon-alianca-do-brasil.ico';
import BancoDoBrasilTextosBold from '../../assets/fonts/BancoDoBrasilTextos-Bold.ttf';
import BancoDoBrasilTextosLight from '../../assets/fonts/BancoDoBrasilTextos-Light.ttf';
import BancoDoBrasilTextosMedium from '../../assets/fonts/BancoDoBrasilTextos-Medium.ttf';
import BancoDoBrasilTextosRegular from '../../assets/fonts/BancoDoBrasilTextos-Regular.ttf';
import BancoDoBrasilTextosXBold from '../../assets/fonts/BancoDoBrasilTextos-XBold.ttf';
import BancoDoBrasilTitulosBold from '../../assets/fonts/BancoDoBrasilTitulos-Bold.ttf';
import BancoDoBrasilTitulosLight from '../../assets/fonts/BancoDoBrasilTitulos-Light.ttf';
import BancoDoBrasilTitulosMedium from '../../assets/fonts/BancoDoBrasilTitulos-Medium.ttf';
import BancoDoBrasilTitulosRegular from '../../assets/fonts/BancoDoBrasilTitulos-Regular.ttf';
import BancoDoBrasilTitulosXBold from '../../assets/fonts/BancoDoBrasilTitulos-XBold.ttf';
import InterBold from '../../assets/fonts/Inter-Bold.ttf';
import InterExtraBold from '../../assets/fonts/Inter-ExtraBold.ttf';
import InterLight from '../../assets/fonts/Inter-Light.ttf';
import InterMedium from '../../assets/fonts/Inter-Medium.ttf';
import InterRegular from '../../assets/fonts/Inter-Regular.ttf';
import { ReactComponent as LogoAliancaDoBrasilHeader } from '../../assets/images/logoAliancaDoBrasilHeader.svg';

const aliancaDoBrasil = {
  id: 'aliancaDoBrasil',
  displayName: 'Aliança do Brasil Seguros | Área do Cliente',
  envAreaLogada: 'REACT_APP_ANGULAR_ALIANCA_URI',
  header: {
    logo: LogoAliancaDoBrasilHeader,
    logoUrl: '',
  },
  favicon,
  gtmId: 'GTM-5F9Q4LTC',
  colors: {
    primary: '#44665C',
    backgroundPrimary: '#3751FF',
    primaryDark: '#5A6FFF',
    primaryLight: '#0a67a2',
    textPrimary: '#4C4C4C',
    secondary: '#FCFC30',
    error: '#F44336',
    surface: '#FFFFFF',
    background: '#F7F7F5',
    backgroundSecondary: '#F3EEFB',
    backgroundDark: '#4E4E4E',
    success: '#4CAF50',
    warning: '#FF9800',
    info: '#2196F3',
    textSecondary: '#4C4C4C',
    textDisabled: '#BDBDBD',
    border: '#E0E0E0',
    borderPrimary: '#C1D1F1',
    divider: '#FCEE4F',
    focus: '#465EFF',
    hover: '#465EFF',
    inverted: '#FFFFFF',
  },
  typography: {
    fontFamily: 'BancoDoBrasilTextos, sans-serif',
    fontFamilyTitle: 'BancoDoBrasilTitulos, sans-serif',
    inputLabelFontFamily: 'Inter, sans-serif',
    inputFieldFontFamily: 'Inter, sans-serif',
    descriptionFontFamily: 'Inter, sans-serif',
    textFontFamilyMap: {
      primary: {
        regular: 'BancoDoBrasilTextos, sans-serif',
        medium: 'BancoDoBrasilTextos, sans-serif',
        bold: 'BancoDoBrasilTitulos, sans-serif',
      },
      secondary: {
        regular: 'BancoDoBrasilTitulos, sans-serif',
        medium: 'BancoDoBrasilTitulos, sans-serif',
        bold: 'BancoDoBrasilTitulos, sans-serif',
      },
      tertiary: {
        bold: 'Inter, sans-serif',
        regular: 'Inter, sans-serif',
        medium: 'Inter, sans-serif',
        italic: 'Inter, sans-serif',
        semibold: 'Inter, sans-serif',
      },
    },
    weights: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    fonts: [
      {
        family: 'BancoDoBrasilTextos',
        weight: 300,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosLight}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 400,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosRegular}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 500,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosMedium}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 700,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosBold}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 900,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosXBold}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 300,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosLight}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 400,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosRegular}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 500,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosMedium}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 700,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosBold}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 900,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosXBold}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 300,
        style: 'normal',
        src: `url(${InterLight}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 400,
        style: 'normal',
        src: `url(${InterRegular}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 500,
        style: 'normal',
        src: `url(${InterMedium}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 700,
        style: 'normal',
        src: `url(${InterBold}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 900,
        style: 'normal',
        src: `url(${InterExtraBold}) format('truetype')`,
      },
    ],
  },
  screens: {
    login: {
      title: '#4C4C4C',
      underlineText: '#758E81',
      SingleCardAccess: {
        title: {
          color: '#4C4C4C',
          fontSize: '24px',
        },
        btnText: {
          color: '#4C4C4C',
          fontSize: '14px',
        },
        backgroundColor: '#F7F7F5',
        border: '#D9D9D4',
        link: '#B9785D',
      },
      CardLogin: {
        btnAcessarBackground: '#44665C',
        btnAcessarBackgroundHover: '#44665C',
        btnAcessarText: '#FEFEFE',
      },
    },
    primeiroAcesso: {
      title: '#4C4C4C',
      background: '#F7F7F5',
    },
    senhaPrimeiroAcesso: {
      title: '#4C4C4C',
      text: '#4C4C4C',
      info: '#4C4C4C',
    },
    usuarioValidadoPage: {
      titulo: '#4C4C4C',
      background: '#F7F7F5',
      containerGrid: {
        background: '#FEFEFE',
      },
    },
    selecaoEnvioCodigoPrimeiroAcesso: {
      texts: {
        title: 'Primeiro Acesso',
        subtitleEmailOnly: 'Você receberá o código por e-mail.',
        subtitleWithPhone: 'Como deseja receber seu código de acesso?',
        labelEmail: 'Receber por e-mail:',
        labelSms: 'Receber por SMS:',
        button: 'CONTINUAR',
      },
      title: '#4C4C4C',
      subtitle: '#5F5F5F',
      background: '#F7F7F5',
      cardBackground: '#FFFFFF',
      selectOption: {
        border: '#EBEBE6',
        selectedBorder: '#D9D9D4',
        selectedShadow: 'none',
        labelColor: '#4C4C4C',
        selectedLabelColor: '#4C4C4C',
        dataColor: '#5F5F5F',
      },
    },
    confirmacaoSeguranca: {
      titulo: '#4C4C4C',
      link: '#B9785D',
      background: '#F7F7F5',
      containerGrid: {
        background: '#FEFEFE',
      },
    },
    esqueciSenhaEmail: {
      title: '#4C4C4C',
    },
    redefinirSenha: {
      titulo: '#4C4C4C',
      link: '#B9785D',
      background: '#F7F7F5',
      formContainer: '#FEFEFE',
      iconeVisibility: '#B9785D',
    },
  },
  components: {
    header: {
      background: '#44665C',
    },
    customButton: {
      background: '#44665C',
      text: '#FFFFFF',
      textTransform: 'uppercase',
    },
    radioGroup: {
      checked: '#44665C',
    },
    customDatePicker: {
      border: '#D9D9D4',
      icon: '#B9785D',
      calendar: {
        headerBackground: '#758E81',
        headerText: '#FFFFFF',
        daySelected: '#C9A25D',
        daySelectedText: '#FFFFFF',
      },
    },
    title: {},
    MuiInputBase: {
      inputColor: '#FF0000',
    },
    MuiOutlinedInput: {
      inputShadow: '0 0 0 100px #fff inset',
    },
    input: {
      border: '#D9D9D4',
      icon: '#B9785D',
    },
    customModal: {
      title: '#5F5F5F',
    },
  },
};

export default aliancaDoBrasil;
